var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column-fluid"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"d-lg-flex flex-row-fluid"},[_c('div',{staticClass:"content-wrapper flex-row-fluid"},[_vm._t("default")],2)])])])}
var staticRenderFns = []

export { render, staticRenderFns }